import { PropertyPartyDTO } from "../DTO/propertyPartyDTO";

export class PropertyParty{
    public id?:number;
    public propertyId!:number;
    public partyType!:string;  //like 'client_attorney','receivers_attorney', etc. its being filled by the party section this party has been created.
    public partyData:PropertyPartyData;

    constructor(){
        this.partyData=new PropertyPartyData();
    }

    public static mapToDTO(param:PropertyParty) : PropertyPartyDTO{
        
        let dto = new PropertyPartyDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.partyType = param.partyType;
            dto.party = JSON.stringify(param.partyData, (key, value) => value ?? undefined);
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyPartyDTO) : PropertyParty
    {
        
        let obj = new PropertyParty();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.partyType = param.partyType;
            if(param.party) {
                let data = <PropertyPartyData>JSON.parse(param.party);
                obj.partyData = Object.assign(new PropertyParty(),data);
            }
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
    
}

export class PropertyPartyData{
    public name?:string;
    public userId?:string;
    public title?:string;
    public entity?:string;
    public ein?:string;
    public company?:string;
    public email?:string;
    public phone?:string;
    public mobile?:string;
    public address?:string;
    public city?:string;
    public state?:string;
    public zip?:string;
    public type?:string;
    public contact?:string;
}